import React from 'react'
import PropTypes from 'prop-types'
import { SocketIO } from '../../core'
import { IOSocketContext } from './SIOSocket'

/**
 * SocketIO Event Listner Component for react
 * usage : <SIOEvent on='eventName' callback={this.onMessage} />
 *
 * @date 2022-10-05
 * @export
 * @class SIOEvent
 * @extends {React.Component}
 */
export class SIOEvent extends React.Component {
  static propTypes = {
    on: PropTypes.string.isRequired,
    room: PropTypes.object,
    member: PropTypes.bool,
    callback: PropTypes.func.isRequired,
  }

  static defaultProps = {
    room: '',
  }

  /**
   *
   *
   * @static
   * @type
   */
  static contextType = IOSocketContext

  componentDidMount() {
    const { on, callback, room, member } = this.props
    const socket = this.context
    socket.on(on, callback)
    room && socket.emit(SocketIO.setting.events.join, room)
    member && socket.on('room', callback)
    member &&
      room.event &&
      socket.emit(SocketIO.setting.events.member, room.event, callback)
  }

  componentWillUnmount() {
    const { on, callback, room, member } = this.props
    const socket = this.context
    socket.off(on, callback)
    room && socket.emit(SocketIO.setting.events.leave, room)
    member && socket.off('room', callback)
  }

  render() {
    return false
  }
}
